export const TABS = {
  DEFAULT: 'group',
  HOMEFEED: 'homefeed',
  PROFILE: 'settings',
  DINNER_PARTY: 'group',
  INBOX: 'inbox',
  LEADER_TOOLS: 'Leader Tools',
};
